import Calendar from "./SVG/calendar.svg?react";

const CalendarIcon = () => {
  return <Calendar />;
};

export default CalendarIcon;
